import { createFileRoute } from '@tanstack/react-router'
import { TemplateDetailPage } from '@/features/agent-templates/template-detail-page'

export const Route = createFileRoute(
  '/_authenticated/automation/templates/$templateId'
)({
  component: TemplateDetailPage,
})
